import React       from "react";

function ButtonPermission(props){
    return (
        <button {...props} className={`${props.className} btn btn-kiroku-` + props.color}>{props.children}</button>
    )
}

export default ButtonPermission;
